import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { metricsTrack } from '../../utilities/analytics/index.js';
import '../../atoms/buttons/enums.js';
import '../../utilities/dom-helpers/index.js';
import stepsDefaults from './data/steps-data.json.js';
import css_248z from './styles/product-selector.scss.js';
import css_248z$1 from './styles/option-card.scss.js';
import css_248z$2 from './styles/results-page.scss.js';
import css_248z$3 from '../../atoms/buttons/generic-button/styles/primary-button.scss.js';
import css_248z$4 from '../../atoms/buttons/generic-button/styles/secondary-button.scss.js';
import css_248z$5 from '../../atoms/buttons/generic-button/styles/platform-hints.scss.js';
import { renderStepsForm } from './layout/index.js';
import { renderResultsPage } from './layout/resultsPage.js';

const LitElementWithUtils = BaseWithUtils(s);
class ProductSelector extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.hasResults = false;
        this.canGetResults = false;
        this.currentStep = 0;
        this.isLastStep = false;
        this.dataCopy = stepsDefaults;
        this.steps = this.dataCopy.steps;
        this.scrollTop = 0;
        this.handleKeyDown = (e) => {
            var _a, _b;
            if (e.key === 'Enter') {
                const path = e.composedPath();
                const targetElement = path[0];
                if (targetElement.tagName.toLowerCase() !== 'input')
                    return;
                (_b = (_a = this.renderRoot
                    .querySelector('ops-step[isexpanded] input[type="radio"]:checked')) === null || _a === void 0 ? void 0 : _a.parentElement.querySelector('.card')) === null || _b === void 0 ? void 0 : _b.click();
            }
        };
    }
    returnString(str) {
        return document.createRange().createContextualFragment(`${str}`);
    }
    initSeps() {
        if (this.data && this.dataCopy === stepsDefaults)
            this.dataCopy = JSON.parse(this.data);
        this.steps = this.dataCopy.steps;
        this.addEventListener('keydown', e => this.handleKeyDown(e));
    }
    updated() {
        this.steps[this.currentStep].active = true;
    }
    connectedCallback() {
        super.connectedCallback();
        this.initSeps();
        metricsTrack('cevt_form_view', {
            dlv_event_category: 'form',
            dlv_event_action: 'view',
            dlv_form_name: this.formName,
            dlv_form_type: this.formName,
            dlv_form_id: this.formId,
        });
    }
    render() {
        return !this.hasResults ? renderStepsForm(this) : renderResultsPage(this);
    }
}
ProductSelector.styles = [
    LitElementWithUtils.styles || [],
    css_248z,
    css_248z$1,
    css_248z$2,
    css_248z$3,
    css_248z$4,
    css_248z$5,
];
__decorate([
    n({ type: String })
], ProductSelector.prototype, "formName", void 0);
__decorate([
    n({ type: String })
], ProductSelector.prototype, "formId", void 0);
__decorate([
    n({ type: Boolean })
], ProductSelector.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean })
], ProductSelector.prototype, "devEnvironment", void 0);
__decorate([
    n({ type: String })
], ProductSelector.prototype, "recommendationImageUrl", void 0);
__decorate([
    n({ type: String })
], ProductSelector.prototype, "recommendationImageAltText", void 0);
__decorate([
    n()
], ProductSelector.prototype, "data", void 0);
__decorate([
    t()
], ProductSelector.prototype, "hasResults", void 0);
__decorate([
    t()
], ProductSelector.prototype, "canGetResults", void 0);
__decorate([
    t()
], ProductSelector.prototype, "currentStep", void 0);
customElements.define('product-selector', ProductSelector);

export { ProductSelector };
